export const solarChoiceConstants = {
    SUBMIT_SOLAR_CHOICE_FORM_REQUEST: "SUBMIT_SOLAR_CHOICE_FORM_REQUEST",
    SUBMIT_SOLAR_CHOICE_FORM_SUCCESS: "SUBMIT_SOLAR_CHOICE_FORM_SUCCESS",
    SUBMIT_SOLAR_CHOICE_FORM_FAILURE: "SUBMIT_SOLAR_CHOICE_FORM_FAILURE",
}